export enum ClientAccessRightsTypesEnum {
    ManagerialRights,
    CashOperationsRights,
    ReportsRights,
    MdsRights,
    UsersRights,
    CurrencyExchangeRights,
    FundPortalRights
}
